import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const DashboardFilterCalendar = ({
  openCalendar,
  setOpenCalendar,
  selectedDate,
  handleDateSelect,
  setCalendarMonth,
  ServerDay,
  highlightedDays,
}) => {
  return (
    <Dialog
      open={openCalendar}
      onClose={() => setOpenCalendar(false)}
      PaperProps={{
        sx: {
          width: { xs: "90%", sm: 400 },
          maxWidth: "100%",
          margin: "auto",
          borderRadius: 2,
        },
      }}
    >
      <DialogContent sx={{ p: 2, overflow: "hidden" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            value={selectedDate}
            onChange={handleDateSelect}
            onMonthChange={(m) => setCalendarMonth(m)}
            slots={{ day: ServerDay }}
            slotProps={{ day: { highlightedDays } }}
          />
        </LocalizationProvider>
      </DialogContent>
    </Dialog>
  );
};

export default DashboardFilterCalendar;
